


















































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import jsZip from "jszip";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenAnswerImageArea from "../../components/SaitenAnswerImageArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import CustomToggle from "../../components/CustomToggle.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import { Sheet, PageItem, FieldItem, TensakuText, ScoreStamp, ParamFieldActivity } from "../../modules/teacher/SaitenInputIchimai"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"

export interface Data {
  initiarizedData: boolean
  sheet: Sheet
  examinee: any
  pageItems: PageItem[]
  base64CorrectImages: string[]
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedCorrectPageIdx: number
  selectedFieldIdx: number,
  selectedStamp: any
  keyCode: string
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  isDispToggre: boolean
  fieldMargin: number
  drawMode: number
  drawColor: string
  thickness: number
  fontSize: number
  lineHeight: number
  textColor: string
  isDragging: boolean
  modeAreaLeft: number
  modeAreaTop: number
  pointerOffsetX: number
  pointerOffsetY: number
  isScrolling: boolean
  selectedScore: number
  scoreOptions: any[]
  isTokutenModeEnable: boolean
  isDispSelectedSheetFieldMark: boolean
  isShowSessionMsg: boolean
  isWarningTimeReached: boolean
  warningDispTime: number
  processingTime: number
  timer: any
  viewedAnswerPageNos: number[]
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-answer-image-area": SaitenAnswerImageArea,
    "preview-image-area": PreviewImageArea,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "text-direction-toggle": TextDirectionToggle,
    "custom-toggle": CustomToggle,
    "v-swatches": VSwatches,
    "text-edit-box": TextEditBox,
  },
  setup(props, context){

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof SaitenAnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof SaitenAnswerImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    const AnswerTypeEnum = Common.AnswerTypeEnum;
    const StmapTypeEnum = Common.StmapTypeEnum;
    const DirectionEnum = Common.DirectionEnum;
    const ScoringTypeEnum = Common.ScoringTypeEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      sheet: null,
      examinee: null,
      pageItems: [],
      base64CorrectImages: [],
      direction: DirectionEnum.Vertical,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedCorrectPageIdx: 0,
      selectedFieldIdx: null,
      selectedStamp: null,
      keyCode: null,
      pcHelpFields: [
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小" },
      ],
      errors: [],
      isDispToggre: false,
      fieldMargin: 0,
      drawMode: Common.DrawModeEnum.None,
      drawColor: "#ff0000",
      thickness: 2,
      fontSize: 32,
      lineHeight: 0,
      textColor: "#ff0000",
      isDragging: false,
      modeAreaLeft: 0,
      modeAreaTop: 0,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isScrolling: false,
      selectedScore: null,
      scoreOptions: [],
      isTokutenModeEnable: false,
      isDispSelectedSheetFieldMark: true,
      isShowSessionMsg: false,
      isWarningTimeReached: false,
      warningDispTime: 9999999,
      processingTime: 0,
      timer: null,
      viewedAnswerPageNos: [1],
    });

    const DrawModeEnum = Common.DrawModeEnum;

    /************************************************************
     * 選択中のページオブジェクトを返却
     ************************************************************/

    const selectedPageItem = computed((): PageItem => {
      if(state.selectedAnswerPageIdx != null){
        return state.pageItems[state.selectedAnswerPageIdx];
      }else{
        return null;
      }
    });

    /************************************************************
     * 選択中の設問を返却
     ************************************************************/

    const selectedFieldItem = computed((): FieldItem => {
      if(state.selectedAnswerPageIdx != null && state.selectedFieldIdx != null){
        return state.pageItems[state.selectedAnswerPageIdx].fieldItems[state.selectedFieldIdx];
      }else{
        return null;
      }
    });

    /************************************************************
     * 選択中のスタンプが添削テキストスタンプか判定
     ************************************************************/

     const isTextStamp = computed((): boolean => {
      return state.selectedStamp && state.selectedStamp instanceof TensakuText;
    });

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
      }
    };

    /************************************************************
     * 模範解答・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const correctArea = document.getElementById(`correct-page-root-${state.direction}-${state.sheet.sheet_type}`);
      const answerArea = document.getElementById(`answer-page-root-${state.direction}-${state.sheet.sheet_type}`);
      const mainArea = document.getElementById("main-area");

      if(correctArea && mainArea){
          const areaW = correctArea.clientWidth - 16;
          const areaH = mainArea.clientHeight - 80;
          
          const scaleW = areaW / state.sheet.width;
          const scaleH = areaH / state.sheet.height;
          const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
          verticalCorrectImageAreaRef.value.inputScale = scale;
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

      if(answerArea && mainArea){
        const areaW = answerArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.sheet.width;
        const scaleH = areaH / state.sheet.height;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
      state.selectedCorrectPageIdx = idx;
      // ページ移動前の設問状態を引き継がないよう、移動先ページの先頭設問を選択
      const fieldIdx = state.pageItems[idx].fieldItems.length > 0 ? 0 : null;
      changeSelectedFieldItem(fieldIdx);
    }

    /******************************
     * 模範解答ページ切り替え時のemit
     ******************************/

     const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * キー押下
     ************************************************************/

     const keyDown = (e:KeyboardEvent) => {
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

     const keyUp = async (e: KeyboardEvent) => {
      state.keyCode = "";

      // API通信中は処理しない
      if(context.root.$store.state.isShowOverlay){
        return;
      }

      // textareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "Backspace"){
        
        if(state.selectedStamp){
          // スタンプ選択中の場合はスタンプ削除
          if(state.selectedStamp instanceof TensakuText){
            deleteTextStamp(state.selectedStamp);
          }else if(state.selectedStamp instanceof ScoreStamp){
            await deleteScoreStamp(state.selectedStamp);
          }
          state.selectedStamp = null;
        }else if(selectedFieldItem.value){
          // スタンプ未選択で設問選択中の場合は、説択設問の採点内容をクリア
          updateCorrectState(null, null);
        }
      }else if(e.key == "h"){
        // Hキー 保存して戻る
        // toSaitenListWithSendSaitenData();
      }else if(e.key == "ArrowRight"){
        // 次の設問
        changeNextFieldItem();
      }else if(e.key == "ArrowLeft"){
        // 前の設問へ移動
        changePrevFieldItem();
      }else if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key) && selectedFieldItem.value){
        const score = Number(e.key);
        if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
          // 正誤採点の部分点採点
          updateCorrectState(CorrectStateEnum.Tokuten, score);
        }else{
          // スタンプ採点の部分点スタンププルダウンの点数切替
          state.selectedScore = selectedFieldItem.value.scoring_type == ScoringTypeEnum.ScoreStampPlus ? score : -score;
        }
      }else if((e.key == "x" || e.key == "f") && selectedFieldItem.value){
        // 誤答採点
        await updateCorrectState(CorrectStateEnum.Gotou, 0);
      }else if((e.key == "o" || e.key == "a") && selectedFieldItem.value){
        // 正答採点
        await updateCorrectState(CorrectStateEnum.Seitou, selectedFieldItem.value.allot);
      }else if(e.key == "y" && selectedFieldItem.value && selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo && state.isTokutenModeEnable){
        // 正誤採点の部分点
        await updateCorrectState(CorrectStateEnum.Tokuten, state.selectedScore);
      }else if((e.key == ";" || e.key == "+") && selectedFieldItem.value){
        // 部分点プルダウンの選択値をプラス
        if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
          if(state.isTokutenModeEnable && state.selectedScore < selectedFieldItem.value.allot - 1){
            state.selectedScore++;
          }
        }else{
          if(state.selectedScore < selectedFieldItem.value.allot){
            state.selectedScore = state.selectedScore == -1 ? 1 : state.selectedScore + 1;
          }
        }
      }else if(e.key == "-" && selectedFieldItem.value){
        // 部分点プルダウンの選択値をマイナス
        if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
          if(state.isTokutenModeEnable && state.selectedScore > 1){
            state.selectedScore--;
          }
        }else{
          if(state.selectedScore > -selectedFieldItem.value.allot){
            state.selectedScore = state.selectedScore == 1 ? -1 : state.selectedScore - 1;
          }
        }
      }
    }

    /************************************************************
     * 設問切替
     ************************************************************/

    const changeSelectedFieldItem = async (selectedFieldIdx: number) => {
      state.selectedFieldIdx = selectedFieldIdx;
      state.selectedStamp = null;

      if(selectedFieldIdx == null){
        return;
      }

      // 部分点プルダウン設定
      state.scoreOptions = new Array<any>();
      if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
        for(let i = 1; i < selectedFieldItem.value.allot; i++){
          state.scoreOptions.push({value: i, text: `${i}点`});
        }
      }else if(selectedFieldItem.value.allot > 1){
        for(let i = -selectedFieldItem.value.allot; i <= selectedFieldItem.value.allot; i++){
          if(i != 0){
            state.scoreOptions.push({value: i, text: `${i}点`});
          }
        }
      }

      // 部分点制御
      if(state.scoreOptions.length > 0){
        state.selectedScore = selectedFieldItem.value.scoring_type == ScoringTypeEnum.ScoreStampMinus ? -1 : 1;
        state.isTokutenModeEnable = true;
      }else{
        state.selectedScore = null;
        state.isTokutenModeEnable = false;
      }

      context.root.$nextTick(async () => {
        const fieldElemId = `${state.direction}-${selectedFieldItem.value.field_activity_id}-parent`;
        const imageAreaElemId = `answer-page-root-${state.direction}-${state.sheet.sheet_type}`;
        const toolboxElemId = "saiten-toolbox";
        
        await scrollToSelectedField(fieldElemId, imageAreaElemId);
        autoMoveToolbox(fieldElemId, toolboxElemId, "modeAreaLeft", "modeAreaTop");
      });
    }

    const scrollToSelectedField = async (targetElemId: string, parentElemId: string) => {

      const targetElem = document.getElementById(targetElemId);
      const parentElem = document.getElementById(parentElemId);

      if(!targetElem || !parentElem){
        return;
      }

      const parentElemWidth = parentElem.offsetWidth;
      const parentElemHeight = parentElem.offsetHeight;
      const parentElemTop = parentElem.scrollTop;
      const parentElemBottom = parentElemTop + parentElemHeight;
      const parentElemLeft = parentElem.scrollLeft;
      const parentElemRight = parentElem.scrollLeft + parentElemWidth;
      const targetElemTop = targetElem.offsetTop;
      const targetElemBottom = targetElem.offsetTop + targetElem.offsetHeight;
      const targetElemLeft = targetElem.offsetLeft;
      const targetElemRight = targetElem.offsetLeft + targetElem.offsetWidth;

      let fromTop = parentElemTop;
      let toTop = parentElemTop;
      let fromLeft = parentElemLeft;
      let toLeft = parentElemLeft;

      if(parentElemTop > targetElemTop || parentElemBottom < targetElemBottom){
        toTop = targetElemTop - (parentElemHeight / 3);
      }

      if(parentElemLeft > targetElemLeft || parentElemRight < targetElemRight){
        toLeft = targetElemLeft - (parentElemWidth / 3);
      }

      if(fromTop != toTop || fromLeft != toLeft){
        state.isScrolling = true;
        await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, parentElem);
        state.isScrolling = false;
      }
    }

    const autoMoveToolbox = (baseElemId: string, toolboxId: string, leftPosName: string, topPosName: string) => {
      context.root.$nextTick(() => {
        const baseElem = document.getElementById(baseElemId);
        const toolbox = document.getElementById(toolboxId);

        if(baseElem && toolbox){
          const clientRect = baseElem.getBoundingClientRect();
          if(clientRect.left + toolbox.clientWidth > window.innerWidth - 20){
            // @ts-ignore
            state[leftPosName] = window.innerWidth - toolbox.clientWidth - 20;
          }else{
            // @ts-ignore
            state[leftPosName] = clientRect.left;
          }

          if(clientRect.top - toolbox.clientHeight - 10 < 0){
            // @ts-ignore
            state[topPosName] = 100;
          }else{
            // @ts-ignore
            state[topPosName] = clientRect.top - toolbox.clientHeight - 10;
          }
        }
      });
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え
     ************************************************************/

    const changeSelectedStamp = (selectedStamp: any) => {
      state.selectedStamp = selectedStamp;

      if(selectedStamp && selectedStamp instanceof TensakuText){
        state.fontSize = selectedStamp.font_size;
        state.lineHeight = selectedStamp.line_height;
        state.textColor = selectedStamp.color;
      }
    }

    /************************************************************
     * テキストスタンプ追加
     ************************************************************/

    const addTextStamp = (tensakuText: TensakuText) => {
      selectedFieldItem.value.tensaku_texts.push(tensakuText);
      selectedFieldItem.value.is_text_stamp_edited = true;
      changeSelectedStamp(tensakuText);
    }

    /************************************************************
     * テキストスタンプ削除
     ************************************************************/

    const deleteTextStamp = (tensakuText: TensakuText) => {
      const idx = selectedFieldItem.value.tensaku_texts.indexOf(tensakuText);
      selectedFieldItem.value.tensaku_texts.splice(idx, 1);
      selectedFieldItem.value.is_text_stamp_edited = true;
      state.selectedStamp = null;
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: state.selectedStamp.font_size, lineHeight: state.selectedStamp.line_height, direction: state.selectedStamp.direction});
      
      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }
      
      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);

      selectedFieldItem.value.is_text_stamp_edited = true;
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間・カラー変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedStamp.font_size = fontSize;
      state.selectedStamp.line_height = lineHeight;
      state.selectedStamp.color = textColor;
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: fontSize, lineHeight: lineHeight, direction: state.selectedStamp.direction});

      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }

      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);

      selectedFieldItem.value.is_text_stamp_edited = true;
    }

    /************************************************************
     * テキストスタンプドラッグ通知
     ************************************************************/

     const textStampDragged = () => {
      selectedFieldItem.value.is_text_stamp_edited = true;
    }

    /************************************************************
     * 部分点スタンプ追加
     ************************************************************/

     const addScoreStamp = async (param: any) => {

      if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
        return;
      }

      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = selectedFieldItem.value.scoreStampIdx++;
      scoreStamp.x = param.point.x;
      scoreStamp.y = param.point.y;
      scoreStamp.height = 50;
      scoreStamp.width = `${state.selectedScore}`.length * scoreStamp.height / 2;
      scoreStamp.score = state.selectedScore;
      scoreStamp.color = "red";
      selectedFieldItem.value.score_stamps.push(scoreStamp);
      selectedFieldItem.value.is_score_stamp_edited = true;

      await updateCorrectStateByScoreStamp();
    }

    /************************************************************
     * 部分点スタンプ削除
     ************************************************************/

    const deleteScoreStamp = async (scoreStamp: ScoreStamp) => {

      if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.Seigo){
        return;
      }

      const idx = selectedFieldItem.value.score_stamps.indexOf(scoreStamp);
      selectedFieldItem.value.score_stamps.splice(idx, 1);
      state.selectedStamp = null;
      selectedFieldItem.value.is_score_stamp_edited = true;
      await updateCorrectStateByScoreStamp();
    }

    /************************************************************
     * 部分点スタンプの得点集計
     ************************************************************/

    const updateCorrectStateByScoreStamp = async () => {

      if(selectedFieldItem.value.score_stamps.length == 0){
        // スタンプ0件は未採点に戻す(スタンプ削除した結果0件になったケース)
        selectedFieldItem.value.correct_state = null;
        selectedFieldItem.value.score = null;
        return;
      }

      // 出力済みの部分点スタンプの合計値取得
      let sumScore = Common.sumArray(selectedFieldItem.value.score_stamps.map(x => x.score));;

      if(selectedFieldItem.value.scoring_type == ScoringTypeEnum.ScoreStampMinus){
        // 減点方式の場合、配点からスタンプの合計点を除算
        sumScore = selectedFieldItem.value.allot + sumScore;
      }

      let correctState: number = CorrectStateEnum.Tokuten;
      if(sumScore <= 0){
        // スタンプ合計点が0点以下の場合は誤答扱い
        sumScore = 0;
        correctState = CorrectStateEnum.Gotou;
      }else if(sumScore >= selectedFieldItem.value.allot){
        // スタンプ合計点が配点以上の場合は正答扱い
        sumScore = selectedFieldItem.value.allot;
        correctState = CorrectStateEnum.Seitou;
      }

      selectedFieldItem.value.correct_state = correctState;
      selectedFieldItem.value.score = sumScore;
    }

    /************************************************************
     * テキストスタンプドラッグ通知
     ************************************************************/

     const scoreStampDragged = () => {
      selectedFieldItem.value.is_score_stamp_edited = true;
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * 採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/
    
    const changeDrawMode = (drawMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedStamp = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 設問の採点内容更新（○×△ボタン or ショートカットキー）
     ************************************************************/

    const updateCorrectState = async (correctState: number, score: number) => {
      if(!selectedFieldItem.value){
        return;
      }

      if(selectedFieldItem.value.scoring_type != ScoringTypeEnum.Seigo && selectedFieldItem.value.score_stamps.length > 0){
        if(!window.confirm("出力されている部分点スタンプは削除されます。採点内容を更新してよろしいですか？")){
          return;
        }
        selectedFieldItem.value.score_stamps = [];
        selectedFieldItem.value.is_score_stamp_edited = true;
      }

      selectedFieldItem.value.correct_state = correctState;
      selectedFieldItem.value.score = score;

      changeNextFieldItem();
    }

    /************************************************************
     * 次の設問へ切り替え
     ************************************************************/

    const changeNextFieldItem = () => {
      state.selectedStamp = null;
      let fieldIdx = 0;
      if(state.selectedFieldIdx == null){
        // 設問未選択の場合は表示しているページの先頭の設問を選択
        fieldIdx = 0;
      }else if(selectedPageItem.value.fieldItems.length > state.selectedFieldIdx + 1){
        // 同ページ内の次設問を選択
        fieldIdx = state.selectedFieldIdx + 1;
      }else if(state.pageItems.length > state.selectedAnswerPageIdx + 1){
        // 次ページの先頭設問を選択
        state.selectedAnswerPageIdx++;
        state.selectedCorrectPageIdx++;
        fieldIdx = 0;
      }else{
        // 最後の設問の場合は選択解除
        fieldIdx = null;
      }

      changeSelectedFieldItem(fieldIdx);
    }

    /************************************************************
     * 前の設問へ切り替え
     ************************************************************/

    const changePrevFieldItem = () => {
      state.selectedStamp = null;
      let fieldIdx = 0;
      if(state.selectedFieldIdx == null){
        // 設問未選択の場合は表示しているページの最後の設問を選択
        fieldIdx = selectedPageItem.value.fieldItems.length - 1;
      }else if(state.selectedFieldIdx > 0){
        // 同ページ内の前設問を選択
        fieldIdx = state.selectedFieldIdx - 1;
      }else if(state.selectedAnswerPageIdx > 0){
        // 前ページの最後の設問を選択
        state.selectedAnswerPageIdx--;
        state.selectedCorrectPageIdx--;
        fieldIdx = selectedPageItem.value.fieldItems.length - 1;
      }else{
        // 先頭の設問の場合は選択解除
        state.selectedFieldIdx = null;
      }

      changeSelectedFieldItem(fieldIdx);
    }

    watch(() => state.selectedAnswerPageIdx, async (newVal, oldVal) => {
      if(!state.viewedAnswerPageNos.includes(newVal + 1)){
        state.viewedAnswerPageNos.push(newVal + 1);
      }
    });

    /************************************************************
     * 保存
     ************************************************************/

    const save = async () => {

      context.root.$store.dispatch("showOverlay");

      const allFieldItems: FieldItem[] = [];
      state.pageItems.forEach(pageItem => {
        pageItem.fieldItems.forEach(x => {
          allFieldItems.push(x);
        });
      });

      // 添削画像をZip化
      let zip = new jsZip();
      allFieldItems.forEach(x => {
        if(x.is_canvas_edited){
          zip.file(`${x.field_activity_id}.png`, x.base64_canvas, {base64: true});
        }

        if(x.is_text_stamp_edited){
          x.tensaku_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`tensaku_text_${y.field_activity_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
        }
      });
      
      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        allFieldItems.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x, state.viewedAnswerPageNos));
        });

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);

        await http.post(`/api/teacher/saiten_input_ichimai/update/${state.sheet.id}/${state.examinee.id}`, fd).then(async response => {
          const correctEditedIds = paramFieldActivities.filter(x => x.is_correct_edited).map(x => x.id);
          allFieldItems.forEach(x => {
            x.correct_state_cache = x.correct_state;
            x.score_cache = x.score;
            // APIで採点内容を更新した設問だけ、画面上も採点済みにする
            if(correctEditedIds.includes(x.field_activity_id)){
              x.saiten_completed = x.correct_state != null;
            }
            x.is_canvas_edited = false;
            x.is_text_stamp_edited = false;
            x.is_score_stamp_edited = false;
          });
          Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
        })
        .catch(async error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/teacher/saiten_input_ichimai?sheet_id=${context.root.$route.params.sheet_id}&examinee_id=${context.root.$route.params.examinee_id}`).then(async response => {
        state.sheet = new Sheet(response.data.sheet);
        state.examinee = response.data.examinee;
        state.base64CorrectImages = response.data.base64_correct_images;
        state.fieldMargin = response.data.buff_size;
        state.warningDispTime = Date.now() + response.data.warning_disp_time;
        for(let i = 0; i < state.sheet.page_count; i++){
          const pageItem = new PageItem(i + 1, state.sheet, response.data.base64_answer_images[i], response.data.sheet_fields, response.data.field_activities, response.data.tensaku_texts, response.data.score_stamps, response.data.base64_canvas_hash_array, response.data.sheet_field_marks, response.data.buff_size);
          state.pageItems.push(pageItem);
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);
      document.body.style.overflow = "hidden";

      state.processingTime = 0;
      state.isShowSessionMsg = false;
      state.isWarningTimeReached = false;
      state.timer = setInterval(() => {
        state.processingTime++;
        if(!state.isWarningTimeReached && Date.now() >= state.warningDispTime){
          state.isShowSessionMsg = true;
          state.isWarningTimeReached = true;
        }
      }, 1000);

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {

      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }

      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.overflow = "";
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      StmapTypeEnum,
      DirectionEnum,
      AnswerTypeEnum,
      ScoringTypeEnum,
      CorrectStateEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalCorrectImageAreaRef,
      selectedPageItem,
      selectedFieldItem,
      isTextStamp,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      correctImagePageChanged,
      keyDown,
      keyUp,
      rootTouchmove,
      changeSelectedFieldItem,
      changeSelectedStamp,
      addTextStamp,
      deleteTextStamp,
      changeText,
      textFormatChanged,
      textStampDragged,
      changeDrawMode,
      changeDrawModeFromChild,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      updateCorrectState,
      addScoreStamp,
      deleteScoreStamp,
      scoreStampDragged,
      save,
     };
  }
})
